import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatusInvitee } from '@shared/constants/constants';

@Pipe({
    name: 'invitationStatusType'
})
export class InvitationStatusTypePipe implements PipeTransform {
    constructor(
        private translation: TranslateService
    ) { }
    transform(value: number): string {
        let result = '';
        const itemsStatusInvitee = StatusInvitee(this.translation);
        if (itemsStatusInvitee){
            const selected = itemsStatusInvitee.find(x => x.id === value);
            if (selected){
                result = selected.text;
            }
        }

        return result;
    }
}
